import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Placeholder from "@/pages/Placeholder";
import Register from "@/pages/Register";
import Login from "@/pages/Login";
import JoinNetwork from "@/pages/JoinNetwork";
import Pricing from "@/pages/Pricing";
import BusinessApply from "@/pages/BusinessApply";
import ChampagnePreview from "@/pages/ChampagnePreview";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import AdminWaitlist from "@/pages/AdminWaitlist";
import AdminAuditLog from "@/pages/AdminAuditLog";
import AdminBusinessLeads from "@/pages/AdminBusinessLeads";
import AdminPricingLeads from "@/pages/AdminPricingLeads";
import FoundationSign from "@/pages/FoundationSign";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/lib/auth";
import { initAnalytics } from "@/lib/analytics";

function App() {
  // Boot Google Analytics 4 once. `initAnalytics` no-ops without a measurement ID.
  useEffect(() => {
    initAnalytics();
  }, []);
  return (
    <AuthProvider>
      <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
        <div className="App bg-[#F7F5F2] min-h-screen">
          <div className="grain" />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Landing />} />
              <Route path="/join-network" element={<JoinNetwork />} />
              <Route path="/preview-champagne" element={<ChampagnePreview />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/register" element={<Register />} />
              <Route path="/login" element={<Login />} />
              <Route path="/business/apply" element={<BusinessApply />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/admin/waitlist" element={<AdminWaitlist />} />
              <Route path="/admin/audit-log" element={<AdminAuditLog />} />
              <Route path="/admin/pricing-leads" element={<AdminPricingLeads />} />
              <Route path="/admin/business-leads" element={<AdminBusinessLeads />} />
              <Route path="/foundation/sign" element={<FoundationSign />} />
              <Route
                path="/dashboard"
                element={
                  <Placeholder
                    audience="Businesses"
                    title="Business Dashboard"
                    subtitle="Your revenue-recovery command centre is being polished. Fill cancellations, manage last-minute slots, and track earnings — all in one place."
                  />
                }
              />
              <Route
                path="/app"
                element={
                  <Placeholder
                    audience="Customers"
                    title="The Book Away App"
                    subtitle="Discover last-minute openings near you and book your look in seconds. The app lands soon on iOS and Android."
                  />
                }
              />
            </Routes>
          </BrowserRouter>
          <Toaster
            position="bottom-right"
            theme="light"
            toastOptions={{
              style: {
                background: "#FFFFFF",
                border: "1px solid rgba(212,175,55,0.4)",
                color: "#2A2724",
              },
            }}
          />
        </div>
      </ReactLenis>
    </AuthProvider>
  );
}

export default App;
